import Bugsnag from "@bugsnag/js";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { contactService } from "@/modules/contacts/store/services/contact-service";
import { DRAFT_CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const importDraftContacts = contactService.injectEndpoints({
  endpoints: builder => ({
    importDraftContacts: builder.mutation({
      query: ({ body, source }) => ({
        url: `contacts/drafts/bulk?source=${source}`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: DRAFT_CONTACT_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(id, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(ANALYTIC_EVENTS.CONTACTS_IMPORTED, data);
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useImportDraftContactsMutation } = importDraftContacts;

